// src/components/ui/SectionTitle.tsx
import React from 'react';

export default function SectionTitle({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <h3 className="txt-small-medium text-fg-secondary mb-2">{children}</h3>
  );
}
